<div class="ion-text-center" *ngIf="title">
  <ion-text [innerHtml]="title"></ion-text>
</div>
<ion-card class="ion-no-margin" [class]="type === 'special_promo_voucher' ? 'card-' + specialPromoVoucher : 'card-' + type" (click)="cardAction()" button>
  <ion-item class="new-cards-item center full-width background-transparent ion-item-no-padding" [class]="type === 'special_promo_voucher' ? 'item-' + specialPromoVoucher : 'item-' + (type ? type : accountTaskType)" lines="none">
    <ng-container *ngIf="type === 'special_promo_voucher' && specialPromoVoucher">
      <ng-container *ngIf="specialPromoVoucher === 'Valentine2023'">
        <ion-img class="blast-promo-title" [src]="'./assets/wedding/img/news/promo/valentine/ballons.svg'" slot="start"></ion-img>
        <ion-img class="blast-promo-title" [src]="'./assets/wedding/img/news/promo/valentine/title_' + language + '.svg'" slot="start"></ion-img>
        <ion-img class="blast-promo-msg" [src]="'./assets/wedding/img/news/promo/valentine/msg_' + language + '.svg'" slot="end"></ion-img>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'FebPayDay23'">
        <ion-grid class="payday-grid full-width ion-no-padding" fixed>
          <ion-row>
            <ion-col size="4">
              <ion-img class="payday-title" [src]="'./assets/wedding/img/news/promo/FebPayDay23/title_' + language + '.svg'"></ion-img>
            </ion-col>
            <ion-col size="4">
              <ion-img class="payday-img" [src]="'./assets/wedding/img/news/promo/FebPayDay23/main.svg'"></ion-img>
            </ion-col>
            <ion-col size="4">
              <ion-img class="payday-msg" [src]="'./assets/wedding/img/news/promo/FebPayDay23/msg_' + language + '.svg'"></ion-img>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === '03032023'">
        <div class="banner-div">
          <ion-img class="banner-img" [src]="'./assets/wedding/img/news/promo/03032023/banner_' + language + '.svg'"></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'WomensDay23'">
        <div class="banner-div">
          <ion-img class="banner-img" [src]="'./assets/wedding/img/news/promo/WomensDay23/banner_' + language + '.svg'"></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'MarPayDay23'">
        <div class="banner-div">
          <ion-img class="banner-img" [src]="'./assets/wedding/img/news/promo/MarPayDay23/banner_' + language + '.svg'"></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === '04042023'">
        <div class="banner-div">
          <ion-img class="banner-img" [src]="'./assets/wedding/img/news/promo/04042023/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'Easter23'">
        <div class="banner-div">
          <ion-img class="banner-img" [src]="'./assets/wedding/img/news/promo/Easter23/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'Ramadan23'">
        <div class="banner-div">
          <ion-img class="banner-img" [src]="'./assets/wedding/img/news/promo/Ramadan23/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'LabourDay23'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/May/LabourDay23/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === '05052023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/May/05052023/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'MotherDay23'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/May/MotherDay23/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === '5202023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/May/5202023/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'MayPayDay23'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/May/MayPayDay23/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'DragonBoat23'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/June/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'FatherDay23'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/June/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'Haji23'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/June/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === '07072023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/July/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'MidYear2023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/July/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'Summer2023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/July/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'SG58th'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Aug/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'SurpriseAug23'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Aug/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'Merdeka66th'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Aug/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '09092023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Sep/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'MalaysiaDay2023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Sep/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'MidAutumn23'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Sep/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '10102023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Oct/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'Halloween2023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Oct/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '11112023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Nov/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'BlackFriday2023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Nov/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '12122023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Dec/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'Christmas2023'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Dec/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'Year2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Jan/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'JanPayDay24'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Jan/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'CNY2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Feb/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'FebPayDay24'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Feb/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'WomensDay2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Mar/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
      <ng-container *ngIf="specialPromoVoucher === 'Ramadan2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Mar/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '04042024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Apr/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'Raya2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Apr/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'MothersDay2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/May/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '5202024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/May/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '06062024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Jun/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'Haji2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Jun/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '07072024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Jul/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'MidYearSale24'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Jul/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'TogetherSG59'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Aug/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'Merdeka67th'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Aug/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '09092024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Sep/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'MalaysiaDay2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Sep/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '10102024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Oct/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'Halloween2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Oct/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '11112024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Nov/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'BlackFriday2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Nov/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === '12122024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Dec/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>

      <ng-container *ngIf="specialPromoVoucher === 'Christmas2024'">
        <div class="banner-div">
          <ion-img class="banner-img" [ngClass]="'img-' + specialPromoVoucher" [src]="'./assets/wedding/img/news/promo/Dec/' + specialPromoVoucher + '/banner_' + language + '.svg'" ></ion-img>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="type === 'account_voucher'">
      <ion-img class="gradient-img-left account_voucher-img" src="./assets/wedding/img/news/discount50.webp" slot="start"></ion-img>
      <ion-text class="lbl account_voucher-lbl ion-text-left" color="dark">
        <div class="div-title account_voucher-title font-14 font-bold line-100" [innerHTML]="'NEWS_CARD.account_voucher.title' | translate"></div>
        <div class="div-msg font-10 line-100" [innerHTML]="'NEWS_CARD.account_voucher.msg' | translate: { voucher: defaultVoucher }" *ngIf="!iosApp"></div>
        <div class="div-msg font-10 line-100" [innerHTML]="'NEWS_CARD.account_voucher.ios' | translate" *ngIf="iosApp"></div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.account_voucher.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-text>
    </ng-container>

    <ng-container *ngIf="type === 'trial_suggestion'">
      <div class="banner-div">
        <div [class]="'img-' + type" [style.background-image]="'url(./assets/wedding/img/news/trial_suggestion/' + language + '.webp)'"></div>
      </div>
    </ng-container>
    
    <ng-container *ngIf="type === 'blast_notice'">
      <ion-text class="lbl blast_notice-lbl ion-text-left" color="dark">
        <div class="div-title blast_notice-title font-14 font-bold line-100" [innerHTML]="'BLAST.notice.' + accountCountry + '.banner.title' | translate">
        </div>
        <div class="div-msg font-10 line-100" [innerHTML]="'BLAST.notice.' + accountCountry + '.banner.msg' | translate">
        </div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'AUP.btn.more' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-text>
      <ion-img class="gradient-img-right blast_notice-img" src="./assets/wedding/img/news/blast/notice/banner.webp" slot="end"></ion-img>
    </ng-container>

    <ng-container *ngIf="type === 'guest_web_launching'">
      <ion-text class="lbl guest_web_launching-lbl ion-text-left ion-no-margin" color="dark">
        <ion-icon class="font-28 new-circle-icon" [src]="'./assets/wedding/icon/new/new-circle-' + (language ? language : 'en') + '.svg'"></ion-icon>
        <div class="div-title guest_web_launching-title line-100">
          <ion-text class="font-14 font-bold" color="dark" [innerHTML]="'NEWS_CARD.guest_web_launching.title' | translate"></ion-text>
        </div>
        <div class="div-msg font-10 line-100" [innerHTML]="'NEWS_CARD.guest_web_launching.msg' | translate">
        </div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'BTN.get_start' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-text>
      <ion-img class="gradient-img-right guest_web_launching-img" [src]="'./assets/wedding/img/website/setting/upgrade.webp'" slot="end"></ion-img>
    </ng-container>

    <ng-container *ngIf="type === 'whatsapp_launching'">
      <ion-text class="lbl whatsapp_launching-lbl ion-text-left" color="dark">
        <div class="div-title whatsapp_launching-title font-14 font-bold line-100" [innerHTML]="'NEWS_CARD.whatsapp_launching.title' | translate">
        </div>
        <div class="div-msg font-10 line-100" [innerHTML]="'NEWS_CARD.whatsapp_launching.msg' | translate">
        </div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.whatsapp_launching.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-text>
      <ion-img class="gradient-img-right whatsapp_launching-img" src="./assets/wedding/img/news/whatsapp_launching.webp" slot="end"></ion-img>
      <!-- <div class="banner-div">
        <div [class]="'img-' + type" [style.background-image]="'url(./assets/wedding/img/news/whatsapp/launching/' + language + '.webp)'"></div>
      </div> -->
    </ng-container>

    <ng-container *ngIf="type === 'web_checkin_launching'">
      <div class="banner-div">
        <ion-img class="banner-img" [ngClass]="'img-' + type" [src]="'./assets/wedding/img/news/web_checkin_launching/banner_' + language + '.webp'"></ion-img>
      </div>
    </ng-container>

    <ng-container *ngIf="type === 'chrome'">
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'NEWS_CARD.chrome.title' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'NEWS_CARD.chrome.msg' | translate"></ion-text></div>
      </ion-label>
      <ion-img class="margin-left" src="./assets/wedding/img/news/chrome.webp" slot="end"></ion-img>
    </ng-container>

    <!-- <ng-container *ngIf="type === 'theme'">
      <div class="banner-div">
        <ion-img class="banner-img theme-img" src="./assets/wedding/img/news/theme/theme.svg" slot="start"></ion-img>
      </div>
    </ng-container> -->

    <ng-container *ngIf="type === 'why_premium'">
      <ion-text class="lbl why_premium-lbl ion-text-left" color="dark">
        <div class="div-title why_premium-title font-14 font-bold line-100" [innerHTML]="'NEWS_CARD.why_premium.title' | translate">
        </div>
        <div class="div-msg font-10 line-100" [innerHTML]="'NEWS_CARD.why_premium.msg' | translate">
        </div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.why_premium.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-text>
      <ion-img class="gradient-img-right why_premium-img" src="./assets/wedding/img/news/why_premium.webp" slot="end"></ion-img>
      <!-- <div class="banner-div">
        <div [class]="'img-' + type" [style.background-image]="'url(./assets/wedding/img/news/why_premium/' + language + '.webp)'"></div>
      </div> -->
    </ng-container>

    <ng-container *ngIf="type === 'account_compare'">
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'PRODUCT_COMPARE.title' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'NEWS_CARD.account_compare.msg' | translate"></ion-text></div>
      </ion-label>
      <ion-img src="./assets/wedding/img/news/account_compare.svg" slot="end"></ion-img>
    </ng-container>

    <ng-container *ngIf="type === 'account_gift'">
      <div class="banner-div">
        <ion-img class="banner-img" [ngClass]="'img-' + type" [src]="'./assets/wedding/img/news/account_gift/' + language + '.webp'"></ion-img>
      </div>
    </ng-container>

    <ng-container *ngIf="type === 'help_center'">
      <ion-img class="gradient-img-left help_center-img" src="./assets/wedding/img/news/help_center.webp" slot="start"></ion-img>
      <ion-text class="lbl help_center-lbl ion-text-left" color="dark">
        <div class="div-title help_center-title font-14 font-bold line-100" [innerHTML]="'NEWS_CARD.help_center.title' | translate">
        </div>
        <div class="div-msg font-10 line-100" [innerHTML]="'NEWS_CARD.help_center.msg' | translate">
        </div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.help_center.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-text>
      
      <!-- <div class="banner-div">
        <div [class]="'img-' + type" [style.background-image]="'url(./assets/wedding/img/news/help_center/' + language + '.webp)'"></div>
      </div> -->
    </ng-container>

    <ng-container *ngIf="type === 'platform'">
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'NEWS_CARD.platfrom.title' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'NEWS_CARD.platfrom.msg' | translate"></ion-text></div>
      </ion-label>
      <ion-img class="platform-img" src="./assets/wedding/img/product/account/wedding_account_full.svg" slot="end"></ion-img>
    </ng-container>

    <ng-container *ngIf="type === 'referral'">
      <ion-img class="margin-right" src="./assets/wedding/img/news/referral.svg" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'REFERRAL.msg.intro' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'REFERRAL.valid.msg' | translate"></ion-text></div>
      </ion-label>
    </ng-container>

    <ng-container *ngIf="type === 'trial_upgrade'">
      <ion-img class="img-trial_upgrade margin-right" src="./assets/wedding/img/news/upgrade.webp"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'NEWS_CARD.trial_upgrade.title' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'NEWS_CARD.trial_upgrade.msg' | translate"></ion-text></div>
      </ion-label>
    </ng-container>

    <ng-container *ngIf="type === 'setup_venue'">
      <ion-img class="gradient-img-left setup_venue-img" src="./assets/wedding/img/news/setup_venue.webp" slot="start"></ion-img>
      <ion-label class="lbl ion-no-margin setup_venue-lbl ion-text-left" color="dark">
        <div class="div-title line-100 font-14 font-bold ion-text-wrap" [innerHtml]="'NEWS_CARD.setup_venue.title' | translate"></div>
        <div class="div-msg line-100 font-10 ion-text-wrap" [innerHtml]="'NEWS_CARD.setup_venue.msg' | translate"></div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.setup_venue.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-label>
    </ng-container>

    <ng-container *ngIf="type === 'invite_couple'">
      <ion-img class="img-invite_couple margin-right" src="./assets/wedding/img/news/invite_couple.webp" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'NEWS_CARD.invite_couple.title' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'NEWS_CARD.invite_couple.msg' | translate"></ion-text></div>
      </ion-label>
    </ng-container>

    <ng-container *ngIf="type === 'migrate_gift'">
      <ion-img class="margin-right" src="./assets/wedding/img/news/migrate_gift.svg" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'NEWS_CARD.migrate_gift.title' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'NEWS_CARD.migrate_gift.msg' | translate"></ion-text></div>
      </ion-label>
    </ng-container>

    <ng-container *ngIf="type === 'review'">
      <ion-img class="margin-right" src="./assets/wedding/img/news/review.svg" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'NEWS_CARD.review.title' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'NEWS_CARD.review.msg' | translate"></ion-text></div>
      </ion-label>
    </ng-container>

    <ng-container *ngIf="accountTaskType === 'setup_visitor_page'">
      <ion-img class="margin-right" src="./assets/wedding/img/account-task/visitor_page.svg" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'CHECKLIST.setup_visitor.title' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'CHECKLIST.setup_visitor.msg' | translate"></ion-text></div>
      </ion-label>
    </ng-container>

    <ng-container *ngIf="accountTaskType === 'add_guest'">
      <ion-text class="lbl add_guest-lbl ion-text-left" color="dark">
        <div class="div-title add_guest-title font-14 font-bold line-100" [innerHTML]="'NEWS_CARD.add_guest.title' | translate">
        </div>
        <div class="div-msg font-10 line-100" [innerHTML]="'NEWS_CARD.add_guest.msg' | translate">
        </div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.add_guest.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-text>
      <ion-img class="gradient-img-right add_guest-img" src="./assets/wedding/img/news/add_guest.webp" slot="end"></ion-img>
      <!-- <ion-img class="margin-right" src="./assets/wedding/img/account-task/new_guest.svg" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'MODULE.action.guest.new' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'CHECKLIST.new_guest.msg' | translate"></ion-text></div>
      </ion-label> -->
    </ng-container>

    <ng-container *ngIf="accountTaskType === 'send_qr'">
      <ion-text class="lbl send_qr-lbl ion-text-left" color="dark">
        <div class="div-title send_qr-title font-14 font-bold line-100" [innerHTML]="'NEWS_CARD.send_qr.title' | translate">
        </div>
        <div class="div-msg font-10 line-100" [innerHTML]="'NEWS_CARD.send_qr.msg' | translate">
        </div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.send_qr.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-text>
      <ion-img class="gradient-img-right send_qr-img" src="./assets/wedding/img/news/send_qr.webp" slot="end"></ion-img>
      <!-- <ion-img class="margin-right" src="./assets/wedding/img/account-task/send_qr.svg" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'QRCODE.btn.send' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'CHECKLIST.send_qr.msg' | translate"></ion-text></div>
      </ion-label> -->
    </ng-container>

    <ng-container *ngIf="accountTaskType === 'invite_member'">
      <ion-img class="gradient-img-left invite_member-img" src="./assets/wedding/img/news/invite_member.webp" slot="start"></ion-img>
      <ion-label class="lbl ion-no-margin invite_member-lbl ion-text-left" color="dark">
        <div class="div-title line-100 font-14 font-bold ion-text-wrap" [innerHtml]="'NEWS_CARD.invite_member.title' | translate"></div>
        <div class="div-msg line-100 font-10 ion-text-wrap" [innerHtml]="'NEWS_CARD.invite_member.msg' | translate"></div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.invite_member.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-label>
      <!-- <ion-img class="margin-right" src="./assets/wedding/img/account-task/invite_member.svg" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'ACCOUNT_SHARE.lbl.invite_member' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'CHECKLIST.invite_member.msg' | translate"></ion-text></div>
      </ion-label> -->
    </ng-container>

    <ng-container *ngIf="accountTaskType === 'assign_seating'">
      <ion-text class="lbl assign_seating-lbl ion-text-left" color="dark">
        <div class="div-title assign_seating-title font-14 font-bold line-100" [innerHTML]="'NEWS_CARD.assign_seating.title' | translate">
        </div>
        <div class="div-msg font-10 line-100" [innerHTML]="'NEWS_CARD.assign_seating.msg' | translate">
        </div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.assign_seating.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-text>
      <ion-img class="gradient-img-right assign_seating-img" src="./assets/wedding/img/news/assign_seating.webp" slot="end"></ion-img>
      <!-- <ion-img class="margin-right" src="./assets/wedding/img/account-task/assign_seating.svg" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'SEATING.btn.assign' | translate: { seating: seatingTypeName }"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'CHECKLIST.assign_seating.msg' | translate"></ion-text></div>
      </ion-label> -->
    </ng-container>

    <ng-container *ngIf="accountTaskType === 'review_setting'">
      <ion-img class="gradient-img-left review_setting-img" src="./assets/wedding/img/news/review_setting.webp" slot="start"></ion-img>
      <ion-label class="lbl ion-no-margin review_setting-lbl ion-text-left" color="dark">
        <div class="div-title line-100 font-14 font-bold ion-text-wrap" [innerHtml]="'NEWS_CARD.review_setting.title' | translate"></div>
        <div class="div-msg line-100 font-10 ion-text-wrap" [innerHtml]="'NEWS_CARD.review_setting.msg' | translate"></div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.review_setting.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-label>
      <!-- <ion-img class="margin-right" src="./assets/wedding/img/account-task/review_setting.svg" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'CHECKLIST.review_setting.title' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'CHECKLIST.review_setting.msg' | translate"></ion-text></div>
      </ion-label> -->
    </ng-container>

    <ng-container *ngIf="accountTaskType === 'checkin_guest'">
      <ion-text class="lbl checkin_guest-lbl ion-text-left" color="dark">
        <div class="div-title checkin_guest-title font-14 font-bold line-100" [innerHTML]="'NEWS_CARD.checkin_guest.title' | translate">
        </div>
        <div class="div-msg font-10 line-100" [innerHTML]="'NEWS_CARD.checkin_guest.msg' | translate">
        </div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.checkin_guest.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-text>
      <ion-img class="gradient-img-right checkin_guest-img" src="./assets/wedding/img/news/checkin_guest.webp" slot="end"></ion-img>
      <!-- <ion-img class="img-checkin_guest margin-right" src="./assets/wedding/img/account-task/checkin_guest.webp" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'MENU.checkin' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'CHECKLIST.checkin_guest.msg' | translate"></ion-text></div>
      </ion-label> -->
    </ng-container>

    <ng-container *ngIf="accountTaskType === 'record_gift'">
      <ion-img class="gradient-img-left record_gift-img" src="./assets/wedding/img/news/record_gift.webp" slot="start"></ion-img>
      <ion-label class="lbl ion-no-margin record_gift-lbl ion-text-left" color="dark">
        <div class="div-title line-100 font-14 font-bold ion-text-wrap" [innerHtml]="'NEWS_CARD.record_gift.title' | translate"></div>
        <div class="div-msg line-100 font-10 ion-text-wrap" [innerHtml]="'NEWS_CARD.record_gift.msg' | translate"></div>
        <div>
          <ion-button class="action-btn" shape="round">
            <ion-text class="font-10">{{ 'NEWS_CARD.record_gift.btn' | translate }}</ion-text>
          </ion-button>
        </div>
      </ion-label>
      <!-- <ion-img class="img-record_gift margin-right" src="./assets/wedding/img/account-task/record_gift.webp" slot="start"></ion-img>
      <ion-label class="ion-no-margin ion-text-wrap">
        <div class="line-100"><ion-text class="font-14 font-bold" [innerHtml]="'CHECKLIST.record_gift.title' | translate"></ion-text></div>
        <div class="line-100"><ion-text class="font-10" [innerHtml]="'CHECKLIST.record_gift.msg' | translate"></ion-text></div>
      </ion-label> -->
    </ng-container>

    <ng-container *ngIf="!type && !accountTaskType">
      <ion-img class="margin-right" src="./assets/wedding/img/account/know_attending_guest.svg" slot="start"></ion-img>
      <ion-text class="font-10" color="dark">{{ 'MSG.coming_soon' | translate }}...</ion-text>
    </ng-container>
  </ion-item>
  
</ion-card>